import React, { Component } from 'react'

export default class Header extends Component {
    render() {
        return (
            <div>
                <header>
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="colorlib-navbar-brand">
                                    <a className="colorlib-logo" href="https://github.com/alfecaesar/alfecaesar-react">Alfe Caesar Lagas</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </header>
            </div>
        );
    }
}